var map = {
	"./en/LsCTA.json": [
		67063,
		7063
	],
	"./en/about.json": [
		82019,
		2019
	],
	"./en/agreements.json": [
		47863,
		7863
	],
	"./en/api.json": [
		80978,
		978
	],
	"./en/apps.json": [
		17818,
		7818
	],
	"./en/bitwala.json": [
		83450,
		3450
	],
	"./en/comingSoon.json": [
		12846,
		2846
	],
	"./en/contact.json": [
		55534,
		5534
	],
	"./en/cryptocurrencies.json": [
		90504,
		504
	],
	"./en/discover.json": [
		84105,
		4105
	],
	"./en/exchanges.json": [
		54528,
		4528
	],
	"./en/features.json": [
		86273,
		6273
	],
	"./en/header.json": [
		55243,
		5243
	],
	"./en/helloCrypto.json": [
		42079,
		2079
	],
	"./en/intelsath.json": [
		97222,
		7222
	],
	"./en/landing.json": [
		64353,
		4353
	],
	"./en/management.json": [
		83445,
		3445
	],
	"./en/marketingLps.json": [
		83603,
		3603
	],
	"./en/markets.json": [
		47795,
		7795
	],
	"./en/newsSection.json": [
		81716,
		1716
	],
	"./en/orders.json": [
		21307,
		1307
	],
	"./en/partnerships.json": [
		89735,
		9735
	],
	"./en/platform.json": [
		26365,
		6365
	],
	"./en/portfolio.json": [
		81854,
		1854
	],
	"./en/press.json": [
		50365,
		365
	],
	"./en/pricing.json": [
		52540,
		2540
	],
	"./en/privacy.json": [
		43750,
		3750
	],
	"./en/referrals.json": [
		83312,
		3312
	],
	"./en/security.json": [
		95028,
		5028
	],
	"./en/securityPolicy.json": [
		53154,
		3154
	],
	"./en/services.json": [
		15370,
		5370
	],
	"./en/servicesCTA.json": [
		91896,
		1896
	],
	"./en/support.json": [
		29421,
		9421
	],
	"./en/supportedExchanges.json": [
		32358,
		2358
	],
	"./en/tables.json": [
		89191,
		9191
	],
	"./en/terms.json": [
		28602,
		6221
	],
	"./en/testimonials.json": [
		43442,
		3442
	],
	"./en/translation.json": [
		44985,
		4985
	],
	"./en/whyUs.json": [
		35552,
		5552
	],
	"./es/LsCTA.json": [
		66112,
		6112
	],
	"./es/about.json": [
		72820,
		2820
	],
	"./es/agreements.json": [
		14690,
		4690
	],
	"./es/api.json": [
		81417,
		1417
	],
	"./es/apps.json": [
		7019,
		7019
	],
	"./es/bitwala.json": [
		1909,
		1909
	],
	"./es/comingSoon.json": [
		87623,
		7623
	],
	"./es/contact.json": [
		58277,
		8277
	],
	"./es/cryptocurrencies.json": [
		54765,
		4765
	],
	"./es/discover.json": [
		96116,
		6116
	],
	"./es/exchanges.json": [
		29887,
		9887
	],
	"./es/features.json": [
		17560,
		7560
	],
	"./es/header.json": [
		92989,
		2989
	],
	"./es/helloCrypto.json": [
		80344,
		344
	],
	"./es/intelsath.json": [
		80701,
		701
	],
	"./es/landing.json": [
		23914,
		3914
	],
	"./es/management.json": [
		46556,
		6556
	],
	"./es/marketingLps.json": [
		20778,
		778
	],
	"./es/markets.json": [
		21448,
		1448
	],
	"./es/newsSection.json": [
		94963,
		4963
	],
	"./es/orders.json": [
		18042,
		8042
	],
	"./es/partnerships.json": [
		31122,
		1122
	],
	"./es/platform.json": [
		64072,
		4072
	],
	"./es/portfolio.json": [
		99153,
		1534
	],
	"./es/press.json": [
		44338,
		4338
	],
	"./es/pricing.json": [
		51307,
		3688
	],
	"./es/privacy.json": [
		25101,
		5101
	],
	"./es/referrals.json": [
		39931,
		9931
	],
	"./es/security.json": [
		56069,
		6069
	],
	"./es/securityPolicy.json": [
		83979,
		3979
	],
	"./es/services.json": [
		52011,
		2011
	],
	"./es/servicesCTA.json": [
		61799,
		1799
	],
	"./es/support.json": [
		4638,
		4638
	],
	"./es/supportedExchanges.json": [
		8699,
		8699
	],
	"./es/tables.json": [
		93658,
		3658
	],
	"./es/terms.json": [
		59990,
		9990
	],
	"./es/testimonials.json": [
		85291,
		5291
	],
	"./es/translation.json": [
		45386,
		5386
	],
	"./es/whyUs.json": [
		66387,
		6387
	],
	"./fr/translation.json": [
		75842,
		5842
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80967;
module.exports = webpackAsyncContext;